import BetaBanner from '../components/BetaBanner.jsx'
import Header from '../components/Header.jsx'
import Footer from '../components/Footer.jsx'

export default function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-white">
      <BetaBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}
